const faqItems = [
  {
    q: '探花系列平台主要提供哪些内容？',
    a: '探花系列是一个精品内容聚合平台，涵盖探花大神合集、探花一区专区、探花91社区精选、探花探花推荐等多个内容板块，每日更新探花精选资源，为探花迷提供一站式内容发现服务。',
  },
  {
    q: '如何快速找到想要的探花大神作品？',
    a: '您可以通过首页的「主题索引」板块按内容类型快速导航，也可以在「排行榜」中查看热门内容。平台支持按探花大神创作者、探花一区主题、探花91社区等多个维度进行内容检索。',
  },
  {
    q: '平台上的探花精选内容多久更新一次？',
    a: '探花系列平台实行每日更新机制，编辑团队每天从社区中筛选优质内容进行推荐。探花一区和探花91的实时内容会随社区动态同步更新，探花精选和探花大神合集则在每日固定时间批量上新。',
  },
  {
    q: '探花探花推荐的内容是如何筛选的？',
    a: '探花探花的推荐系统综合了编辑评分、用户浏览数据和社区口碑三个维度。探花精选内容经过人工审核把关，确保推送的每一条极品探花资源都符合平台质量标准。',
  },
  {
    q: '九一探花和探花一区有什么区别？',
    a: '探花一区是平台内容分类专区，按主题和类型组织内容索引；九一探花则是指探花91社区中的特定内容板块，侧重社区互动和用户推荐。两者都属于探花系列平台的重要组成部分。',
  },
  {
    q: '是否可以投稿自己的探花内容到平台？',
    a: '欢迎探花大神创作者投稿！您可以通过「投稿与合作」板块联系我们。投稿内容需符合探花系列平台的内容规范，我们的编辑团队会对投稿进行审核，优质作品将收录至探花精选或探花大神合集。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-18 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-4">
            <i className="ri-question-answer-line"></i>
            帮助中心
          </div>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            常见问答
          </h2>
          <p className="mt-2 text-sm text-foreground-500 max-w-lg mx-auto">
            关于探花系列平台的常见问题解答
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden"
            >
              <div className="p-4 md:p-5">
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-primary-100 flex items-center justify-center shrink-0 mt-0.5">
                    <span className="text-[11px] font-bold text-primary-600">Q</span>
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm md:text-base font-semibold text-foreground-800 mb-2">
                      {item.q}
                    </h3>
                    <div className="flex items-start gap-3">
                      <div className="w-6 h-6 rounded-full bg-accent-100 flex items-center justify-center shrink-0 mt-0.5">
                        <span className="text-[11px] font-bold text-accent-600">A</span>
                      </div>
                      <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}